// extracted by mini-css-extract-plugin
module.exports = {"tabs_nav":"tabs-pill_tabs_nav__pm4iC","tab_button":"tabs-pill_tab_button__BSG8f","active":"tabs-pill_active__aECz6","tab_content":"tabs-pill_tab_content__raSIq"};